<template>
  <Section class="pb-4">
    <template #header class="align-center">
      <div class="mr-auto">
        <strong>Membership</strong>
      </div>
      <SubscriptionSettingsDialog :pro="me" />
    </template>

    <div class="mx-n3">
      <v-divider />
    </div>
    <div class="px-2">
      <div class="pt-2 black--text d-flex">
        <div>{{ renewal_message.message }}</div>
        <div class="ml-auto">{{ renewal_message.date }}</div>
      </div>
      <div class="pt-1 black--text d-flex" v-if="me.membership_price_cents">
        <div>You will be charged:</div>
        <div class="ml-auto">{{ formatCurrency(me.membership_price_cents) }}
          <em>(+ tax)</em>
        </div>
      </div>

      <div class="pt-3">
        <span class="black--text">Your plan includes:</span>
        <ul>
          <li>Quality leads from your partners</li>
          <li>Tools to manage opportunity status</li>
          <li>The ability to easily find Customer information</li>
          <li>Visibility into the value of your Partners</li>
        </ul>
      </div>

    </div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import SubscriptionSettingsDialog from '../dialogs/SubscriptionSettings'
import { mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'ValidMembershipSection',

  components: { 
    Section,
    SubscriptionSettingsDialog,
  },

  computed: {
    ...mapGetters('auth', ['me']),

    renewal_message() {
      if (this.me.membership_last_valid_time) {
        return {
          message: 'Your membership is valid through:',
          date: this.formatDate(this.me.membership_last_valid_time),
        }
      }

      return {
        message: 'Your membership is currently complementatory',
        date: '',
      }
    }
  },

  methods: {
    ...formatters,
  },
}
</script>
